// Shared JS viewport breakpoints for ad logic (min-width, px). Mirror the SCSS
// $width-desktop / $width-tablet breakpoints used by the editorial layout.
export const DESKTOP_MIN_WIDTH = 1080;
export const TABLET_MIN_WIDTH = 768;
